import Footer from "../../components/footer"
import Menu from "../../components/menu"
import useAuth from "../../hooks/useAuth"


import { useInfiniteQuery } from '@tanstack/react-query'

import { authApi } from "../../services/api/api";

import { toast, ToastContainer } from "react-toastify";
import SkeletonIndications from "../../components/skeletons/home/indications";
import { useState } from "react";
import LastIndications from "../../components/lastIndications";
import LastBooksHome from "../../components/lastBooksHome";

export default function Dashboard() {

    const api = authApi()

    const { user, theme } = useAuth()

    //------------------------------------------last indications-----------------------------

    const SKELETON_COUNT = 4;

    // Função auxiliar para renderizar múltiplos skeletons
    const renderSkeletons = (count) => {
        return Array.from({ length: count }).map((_, i) => (
            <SkeletonIndications key={`skeleton-${i}`} />
        ));
    };
    const getLastIndications = async ({ pageParam }) => {

        const data = await api.getIndications(pageParam.nextPage, 8)
        return data
    }

    let last_pages = false
    let last_pages1 = false

    const { data: lastIndications, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        queryKey: ['lastIndications'],
        queryFn: getLastIndications,
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages) => {

            const nextPage = allPages.length + 1



            if (nextPage >= lastPage.last_page) {
                last_pages = true
            } else {
                last_pages = false
            }

            return { nextPage, last_pages }

        }
    })

    //------------------------------------------last indications-----------------------------

    const getLastBooks = async ({ pageParam }) => {

        const data = await api.getBooks(pageParam.nextPage)
        return data
    }

    const { data: lastBooks, fetchNextPage: fetchNextPageBooks, isFetchingNextPage: loadNest } = useInfiniteQuery({
        queryKey: ['lastBooks'],
        queryFn: getLastBooks,
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages) => {

            const nextPage = allPages.length + 1



            if (nextPage >= lastPage.last_page) {
                last_pages1 = true
            } else {
                last_pages1 = false
            }

            return { nextPage, last_pages1 }

        }
    })

    return (
        <div className={`main w-screen bg-white ${theme}`}>
            <Menu />
            <div className="content w-screen min-h-screen flex justify-center dark:bg-[#061c3f]">

                <div className="w-full max-w-[1900px] flex justify-center">
                    <div className="w-full p-8 ">
                        <div className="flex flex-col gap-1">
                            <span className="text-[10px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-[0.3em]">
                                Comunidade
                            </span>
                            <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">
                                Últimas Indicações
                            </h2>
                            <div className="w-full h-[1px] bg-gray-100 dark:bg-slate-600 mt-4"></div>
                        </div>

                        <div className="mt-4 rounded p-2 grid 2xl:grid-cols-8 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-6 justify-center w-full">
                            {/* Ajuste: Carregamento Inicial com múltiplos skeletons */}
                            {lastIndications?.pages ? (
                                lastIndications.pages.map((page) =>
                                    page.data.map((item) => <LastIndications key={item.id} item={item} />)
                                )
                            ) : renderSkeletons(SKELETON_COUNT)}

                            {/* Ajuste: Carregamento do "Carregar Mais" também com múltiplos skeletons */}
                            {isFetchingNextPage && renderSkeletons(SKELETON_COUNT)}
                        </div>
                        <div className="w-full flex justify-center my-2">
                            {!last_pages &&
                                <button onClick={() => fetchNextPage()} className={`dark:bg-[#2d3d5780] dark:hover:bg-slate-600 bg-gray-200 text-gray-600 duration-300 hover:bg-gray-300 rounded-lg py-2 text-sm px-5 `}>
                                    Carregar mais
                                </button>
                            }
                        </div>

                        <div className="mt-8 w-full">
                            <div className="flex flex-col gap-1">
                                <span className="text-[10px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-[0.3em]">
                                    Novidades
                                </span>
                                {/* Título Principal Clean */}
                                <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">
                                    Últimos Livros Adicionados
                                </h2>
                                <div className="w-full h-[1px] bg-gray-100 dark:bg-slate-600 mt-4"></div>
                            </div>
                            <div className="mt-4 rounded p-2 grid 2xl:grid-cols-8 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-6 justify-center w-full">
                                {/* Ajuste: Carregamento Inicial de Livros */}
                                {lastBooks?.pages ? (
                                    lastBooks.pages.map((page) =>
                                        page.data.map((item) => <LastBooksHome key={item.id} item={item} />)
                                    )
                                ) : renderSkeletons(SKELETON_COUNT)}

                                {/* Ajuste: Carregamento ao buscar próxima página de livros */}
                                {loadNest && renderSkeletons(SKELETON_COUNT)}
                            </div>
                            <div className="w-full flex justify-center py-20">
                                {!last_pages1 &&
                                    <button onClick={() => fetchNextPageBooks()} className={`dark:bg-[#2d3d5780] dark:text-white dark:hover:bg-slate-600 bg-gray-200 text-gray-600 duration-300 hover:bg-gray-300 rounded-lg py-2 text-sm px-5 `}>Carregar mais</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            {/* <Footer/> */}
        </div>
    )
}